import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
import { styled } from "@material-ui/core";
import Loader from "react-loader-spinner";

const Progress = () => {
  // const classes = useStyles();

  let intervalID;

  const handleBeaconDisplay = () => {
    if (document.getElementById("beacon-container")) {
      document.getElementById("beacon-container").style.display = "none";
      stop();
    }
  };

  const stop = () => {
    clearInterval(intervalID);
  };

  const start = () => {
    intervalID = setInterval(handleBeaconDisplay, 200);
  };

  React.useEffect(() => {
    start();
  }, []);

  return (
    <LoaderConatiner>
      <Loader
        type="Oval"
        color="#1c2b49"
        height={100}
        width={50}
        timeout={0} //3 secs
      />
    </LoaderConatiner>
  );
};

export default Progress;

const LoaderConatiner = styled("div")({
  width: "100%",
  height: "100vh",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});
